// Values substituted into a phrase's `{placeholder}` tokens.
export type PhraseValues = Record<string, string | number | null | undefined>;

// Replaces `{name}` (whitespace-tolerant) tokens in a resolved phrase/translation
// with the provided values. Returns the input untouched when there are no
// placeholders. Shared so every app substitutes variables the same way.
const replaceVariables = (text: string, values?: PhraseValues): string => {
  if (!text.includes("{")) {
    return text;
  }
  const entries = Object.entries(values ?? {});
  return entries.reduce((accumulated, [key, value]) => {
    const regex = new RegExp(`{\\s*${key}\\s*}`, "g");
    return accumulated.replace(regex, value?.toString() ?? "");
  }, text);
};

export default replaceVariables;
